import { render, staticRenderFns } from "./multiGoodsItem.vue?vue&type=template&id=dc573776&scoped=true&"
import script from "./multiGoodsItem.vue?vue&type=script&lang=js&"
export * from "./multiGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./multiGoodsItem.vue?vue&type=style&index=0&id=dc573776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc573776",
  null
  
)

export default component.exports